import React, {useEffect, useState} from "react";
import TopSection from "./TopSection";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import MiddleSection from "./MiddleSection";
import utilsFunction from "../../../utils/utilsFunction";
import {useLocation, useNavigate} from "react-router-dom";
import {useHotkeys} from "react-hotkeys-hook";
import numeric from "../../../utils/NumericFunction";
import HotKeyGuide from "./HotKeyGuide";
import "./style.scss"

import {
  addIndexRowToTable, addTafsiliOrDirectMoien, addUniqId, CalculateInformationUnderTable, drawNew, holderAndDirectMoien
} from "./functions";
import {useDispatch, useSelector} from "react-redux";
import {prefixUrl} from "../../../utils/utilsData";
import ControlUnderTable from "../SubmitDocumentForm/ControlUnderTable";
import {initialSendData, submitDocumentFormAction} from "../../Store/SubmitDocumentForm";

const SubmitDocumentForm = (props) => {

  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();

  const [reload, setReload] = useState(0)


  const navigateTo = useNavigate();

  const getDocumentPageData = async (sendData) => {

    try {
      const result = await _axios
        .get(prefixUrl() + "/accountingDocument/?request=documentPageData")

      if (result.data) {

        //dispatch(submitDocumentFormAction.fillInput({documentPageData: result.data}))
        const temp = {...sendData}

        temp.documentPageData = result.data;
        return temp;

      }
      return undefined
    } catch (error) {
      console.log(error)
    }

  }
  const getDataForEdit = async (newSendData, stateId) => {
    try {
      const result = await _axios
        .get(prefixUrl() + '/accountingDocument/?request=documentData&documentCode=' + stateId)


      //  alert()
      //  console.log(result.data)
      if (result.data.status) {


        const res = {...newSendData, ...result.data.documentData}
        res.tableData = res.documentDetails
        delete res.documentDetails
        //dispatch(submitDocumentFormAction.fillInput({documentPageData: result.data}))
        return res;
      }
      return undefined
    } catch (error) {
      console.log(error)
    }

  }


  useHotkeys("ctrl+Enter", (e) => {
    e.preventDefault();
    submitDataHandler()

  });
  useHotkeys("ctrl+o", (e) => {
    e.preventDefault();
    document.getElementById("upload").click();
  });

  // useHotkeys("Enter", (e) => {
  //   e.preventDefault();
  //   onSubmitMiddleData()
  // });
  useHotkeys("ctrl", (e) => {
    e.preventDefault();
  });
  const addHelper = (res) => {


    let mySendData = {...res}


    mySendData.tableData = mySendData.tableData.map(v => {
      const row = {...v};

      if (row.accountCode !== "") {
        const value = row.accountCode;
        const filteredData = mySendData.documentPageData.accounts.filter(row => row.value === value)[0]
        //
        row['holder'] = filteredData?.hasSubAccount ? JSON.stringify(filteredData) : undefined
        //

      }
      return row
    })

    return mySendData
  }


  const addMode = (mySendData) => {
    let sendData = {...mySendData}

    if (sendData.mode === "add") {

      let documentCodes = sendData?.documentPageData?.id;
      let length = documentCodes?.length;
      const documentCode = documentCodes[length - 1]

      const options = {
        year: "numeric", month: "2-digit", day: "2-digit", calendar: "persian",
      };
      const todayDate = new Date().toLocaleDateString("fa-IR", options);

      let time = new Date().toLocaleTimeString("fa-IR", {
        calendar: "persian", hour: "2-digit", minute: "2-digit", second: "2-digit",
      });
      time = numeric.p2e(time);


      dispatch(submitDocumentFormAction.fillInput({
        ...sendData,
        documentDate: numeric.p2e(todayDate), documentTime: time, documentCode: documentCode
      }))
    }
  }

  useEffect(() => {


    if (myLocation?.state?.id) {
      getDocumentPageData(sendData).then((newSendData) => {
        getDataForEdit(newSendData, myLocation?.state?.id).then(res => {

          {

            let sendData = {...res}
            sendData.tableData = addUniqId(sendData.tableData)


            // sendData.tableData = addTafsiliOrDirectMoien(sendData.tableData)
            // sendData = addHelper(sendData)
            // sendData.tableData = addTafsiliOrDirectMoien(sendData.tableData)

            sendData = holderAndDirectMoien(sendData)


            console.log("=========================")
            console.log(sendData)
            console.log("=========================")
            dispatch(submitDocumentFormAction.fillInput(sendData))
          }
          // por kardan tafsili

        })
      })

      // _axios.get(prefixUrl() + '/accountingDocument/?request=documentData&documentCode=' + myLocation?.state?.id)
      //   .then((res) => {
      //
      //     if (res.data.status) {
      //       const myData = res.data.documentData
      //       myData.tableData = myData.documentDetails;
      //       delete myData.documentDetails
      //
      //
      //       myData.tableData = addUniqId(myData.tableData)
      //       myData.tableData = addTafsiliOrDirectMoien(myData.tableData)
      //
      //       console.log(myData.tableData)
      //       dispatch(submitDocumentFormAction.fillInput({...myData}))
      //     }
      //
      //
      //   }).then(res => {
      //   // if tafsili in table Data has a value we should pass a  lable Value
      //
      //
      //   setTimeout(() => {
      //     const newTableData = checkIfThereIsHelper()
      //     //dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))
      //
      //   }, 2000)
      //
      //
      // })

    } else {
      getDocumentPageData({...sendData}).then((newSendData) => {
        addMode(newSendData)
      })
    }
  }, [dispatch, reload])


  useEffect(() => {
    addIndexRowToTable(sendData.tableData, dispatch)
  }, [sendData.remainToBalance, sendData.sumOfBed, sendData.sumOfBes,]);

  useEffect(() => {


    const {sumOfBed, sumOfBes, remainToBalance} = CalculateInformationUnderTable(sendData.tableData)


    const {besWidth, bedWidth, isShow} = drawNew({sendData, sumOfBed, sumOfBes, remainToBalance})


    dispatch(submitDocumentFormAction.fillInput({
      sumOfBed, sumOfBes, remainToBalance, chartDataUnderTable: {besWidth, bedWidth, isShow}

    }))
  }, [sendData.tableData, dispatch])


  useEffect(() => {
    //dispatch(getDocumentPageData())


  }, [dispatch, reload]);

  useEffect(() => {
    //addMode();
  }, [sendData?.documentPageData?.id, reload]);


  const myLocation = useLocation();


  useEffect(() => {
    return () => {
      dispatch(submitDocumentFormAction.fillInput({...sendData}))
    }
  }, []);

  const submitDataHandler = async () => {

    const dataToSend = {...sendData}
    // alert(dataToSend.data.mode)
    // return;

    // if (dataToSend.request !== "documentConfirm") {
    //   toast.error("مقدار درخواستی در آبجکت ارسالی صحیح نیست!");
    //   return;
    // }

    if (dataToSend.mode !== "add" && dataToSend.mode !== "edit") {
      toast.error("مود ارسالی برای افزودن یا ویرایش صحیح نیست.");
      return;
    }
    if (dataToSend.documentCode === "") {
      toast.error("فیلد شماره سند خالی است.");
      return;
    }

    if (dataToSend.documentDescription === "") {
      toast.error("توضیحات سند خالی است.");
      return;
    }
    if (dataToSend.documentDate === "") {
      toast.error("فیلد تاریخ خالی است.");
      return;
    }
    if (dataToSend.documentTime === "") {
      toast.error("فیلد ساعت خالی است.");
      return;
    }

    // ممکنه کاربر یه کد سندی رو وارد کنه که اصلا معتبر نیست. چرا که باید انتخاب کنه


    function removeCommaInTableData(data) {
      data.forEach((v) => {
        v.bed = utilsFunction.removeComma(v.bed + "");
        v.bes = utilsFunction.removeComma(v.bes + "");
      });
      return data;
    }

    dataToSend.documentDetails = sendData.tableData
    dataToSend.documentDate = numeric.p2e(dataToSend.documentDate);

    delete dataToSend.documentPageData
    delete dataToSend.remainToBalance
    delete dataToSend.sumOfBed
    delete dataToSend.sumOfBes
    delete dataToSend.tableData

    console.log(dataToSend)

    const res = await _axios.post(prefixUrl() + "/accountingDocument/", {
      request: "documentConfirm", data: dataToSend,

    });

    if (res.data) {


      const data = res.data;
      if (data.status) {
        toast.success(data.message);


        dispatch(submitDocumentFormAction.fillInput(initialSendData))

        const newRnd = Math.random() * 10000;
        setReload(newRnd)
        // if (afterSubmitRedirect.url) {
        //   navigateTo(afterSubmitRedirect.url, {
        //     state: {data: afterSubmitRedirect.data},
        //   });
        //   return;
        // }
        if (dataToSend.mode === "edit") {
          navigateTo(-1)
        }


      } else {
        toast.error(data.message);
      }


    }

  }


  try {
    return (<div
      className={"submit_document_form_class py-3 px-4"}
      style={{
        width: "100%", margin: "0 auto", height: "88vh", overflow: "scroll", fontSize: 13, marginTop: 10,

      }}
    >
      <div
      >
        {(<>
          <TopSection/>
          <hr style={{margin: 5, color: '#dadada', border: '1px solid #dadada'}}/>

          <MiddleSection/>
          <hr/>
          <ControlUnderTable/>

          <hr/>
          <div className={"w-100 text-start d-flex justify-content-lg-between"}>
            <HotKeyGuide/>


            <></>
            <button
              className={'btnCustom btnSubmit'}
              onClick={submitDataHandler}
            >
              {" "}
              ثبت
            </button>
          </div>


        </>)}
      </div>

    </div>);
  } catch (error) {
    console.log(error)
    return <>{error.toString()}</>
  }

};

export default SubmitDocumentForm;
